<template>
      <!-- Main content -->
  <div class="main-content" id="panel">
    <!-- Topnav -->
    <!-- <Header /> -->
    <!-- Header -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-6">
              <h2>Manage Cusip</h2>
            </div>
            <div class="col-lg-3 col-6 text-right bid">
                <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                  <i @click="searchCusip()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                  <input v-on:keyup.enter="searchCusip" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search cusip" aria-label="Search">
                  <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                </form>
                
              </div>
               <div class="col-lg-3 col-6 text-right bid">
                <button v-if="isAdmin || isEditor"  @click="openUploadSMFileModal()" type="button" class="btn btn-success rounded"><i class="fas fa-user-plus"></i>UPLOAD SECURITY MASTER FILE</button>
               </div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <div class="container-fluid mt--6">
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                   <tr >
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                      @click="sort('cusip')">CUSIP/COUPON/DESC</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                      @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'state'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'state'  ? 'sort-desc' : '']"  
                      @click="sort('state')">STATE/<br>INSURER</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offeringTypeId'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offeringTypeId'  ? 'sort-desc' : '']"  
                      @click="sort('offering_type_id')">Product</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']"  
                      @click="sort('status')"
                    >Status</th>
                    <th scope="col" class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p>
                    </td>
                  </tr>
                  <tr v-for="cusip in cusips" :key="cusip.id" @click="getCusipDetails(cusip)" v-bind:class="{'active-row': cusip.isActive}">
                    <td>
                      <span class="cusips">{{cusip.cusip}}</span>
                      <span class="coupon">{{cusip.coupon | percent(3)}}</span>
                      <span class="desc">{{cusip.description}}</span>
                    </td>
                    <td class="text-center">
                      <span class="maturity">{{moment(cusip.maturityDate).format("MM/DD/YYYY")}}</span><br>
                      {{cusip.callDate ? moment(cusip.callDate).format("MM/DD/YYYY") : "N/A"}}
                      
                    </td>
                    <td>
                      <span class="state">{{getStateName(cusip.stateId)}}</span>
                      <span class="insurer">{{cusip.bondInsurer}}</span>
                    </td>
                    <td>
                      {{getProductName(cusip.offeringTypeId)}}
                    </td>
                    <td class="text-center"><span class="badge" v-bind:class="cusip.status == 'ACTIVE' ? 'active' : 'deactive'">{{cusip.status}}</span></td>
                    <td class="text-center">
                      <div class="d-inline-flex">
                      <a  @click="cusipEditPopupOpen(cusip)" class="editbtn"><i class="fas fa-pen-square green"></i></a>
                      <a v-if="isAdmin || isEditor" href="#"
                      data-toggle="modal"
                      data-target="#cancel-cusip" class="btn-width">
                        <button v-if="cusip.status == 'ACTIVE'" @click="selectedCusip = cusip" type="button" class="btn btn-danger btn-sm my-2"><i class="fas fa-ban"></i> BLOCK</button>
                        <button v-if="cusip.status == 'BLOCKED'"  @click="selectedCusip = cusip" type="button" class="btn btn-secondary btn-sm my-2"><i class="fas fa-check"></i> UNBLOCK</button>
                      </a> 
                      </div>
                      </td>
                    </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getCusipList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <!-- Modal -->
      <div
        class="modal fade"
        id="cancel-cusip"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h3>Are you sure you want to {{selectedCusip.status == 'BLOCKED' ? "unblock" : "block"}} this CUSIP?</h3>
              <p>{{selectedCusip.cusip}}</p>
              <p>{{selectedCusip.description}}</p>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">CANCEL</button>
              <button type="button" class="btn btn-danger" @click="changeCusipStatus(selectedCusip)" >{{selectedCusip.status == 'BLOCKED' ? "UNBLOCK" : "BLOCK"}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
     <add-cusip 
        v-bind:addCusipObj="addCusipObj" 
        v-if="cusipModalOpen" 
        @close="closeAddCusipModal()"
       ></add-cusip>
      <smfileImport
        v-if="smFileModalOpen" 
        @close="smFileModalOpen = false"
       ></smfileImport> 
  </div>
  
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import AddCusip from "../trader/bid/AddCusip";
import smfileImport from "@/components/common/UploadSMFileModal.vue"

export default {
  name: "admin-manage-cusip",
   components: {
     AddCusip,
     smfileImport
    // Footer
  },
  data() {
    return {
      accessToken: null,
      cusips: [],
      config: config,
      loading : false,
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 0,
      selectedCusip : "",
      sortColumn: "cusip",
      sortOrder: "ASC",
      stateConstants: stateConstants,
      cusipValidationErrors : [],
       addCusipObj : {
        cusip: "",
        maturityDate: "",
        description: "",
        bondInsurer: "",
        stateId: "",
        coupon: "",
        callDate: "",
        ratingSP: "",
        ratingMoody: ""
      },
      cusipModalOpen : false,
      isAdmin: false,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      smFileModalOpen : false

    };
  },
  methods: {
    cusipEditPopupOpen(cusip){
      this.cusipValidationErrors = [];
      var editCusip = {...cusip};
      editCusip.ratingSP = editCusip.ratingSP ? editCusip.ratingSP.trim(): "";
      editCusip.ratingMoody = editCusip.ratingMoody ? editCusip.ratingMoody.trim() : "";
      editCusip.coupon =  this.toPercentage(editCusip.coupon,3);
      editCusip.offeringTypeId = editCusip.offeringTypeId ? editCusip.offeringTypeId : "";
      this.addCusipObj = editCusip;
      this.cusipModalOpen = true;
    },
     openUploadSMFileModal(){
      this.smFileModalOpen = true;
    },
    toPercentage(value, decimals){
       if (!value) {
        value = 0
      }
      if (!decimals) {
        decimals = 0
      }
      value = value * 100
      value = value.toFixed(decimals)
      return value
    },
     closeAddCusipModal(){
      this.cusipModalOpen = false;
      this.getCusipList(this.currentPage);
    },
    searchCusip(){
      this.getCusipList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getCusipList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getCusipList();
    },
    getProductName(id){
      if(id == 1){
        return "MUNICIPAL"
      }
      if(id == 2){
        return "CORPORATE"
      }

      return 'N/A'

    },
    changeCusipStatus(selectedCusip){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .put(
          config.baseUrlBidSide + "/cusip/status",
          {
            cusipId : selectedCusip.id,
            cusipStatus : selectedCusip.status == 'BLOCKED' ? "ACTIVE" : "BLOCKED"
          },
          auth
        )
        .then(() => {
          console.log(window);
          window.$("#cancel-cusip").modal("hide");
          this.getCusipList(this.currentPage);
          this.$alert(this.appMessages.cusipStatusChanged);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getCusipList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/cusip/list?page=" +
            currentPage +
            "&size=" +
            this.perPage +
            "&cusip=" +
            this.searchValue +
            "&status=ACTIVE,BLOCKED"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&type=BID",
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(cusip) {
           cusip.isActive = false;
          });
           this.cusips = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    getCusipDetails(cusipSelected){
      this.cusips.forEach(function(cusip) {
        cusip.isActive = false;
      });
      cusipSelected.isActive = true;
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    }
    
  },
  mounted() {
     this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getCusipList();
      }
     }); 
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
        //console.log("isa",this.isAdmin);
      });
  }
};
</script>